import CartEmpty from './Icon'
import { Title } from '../common/Title'
import * as S from './styled'

const EmptyCart = () => (
  <S.Wrapper>
    <S.Header>
      <Title>Você não possui itens adicionados ao seu carrinho.</Title>
    </S.Header>
    <CartEmpty />
  </S.Wrapper>
)

export default EmptyCart
